import { render, staticRenderFns } from "./office-department.vue?vue&type=template&id=35ec5c64&"
import script from "./office-department.vue?vue&type=script&lang=js&"
export * from "./office-department.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports